import type { PageData } from '../../utils/utils'
import { axiosInstance } from '../../utils/utils'

export abstract class BaseApi<T> {
  url = ''
  axiosInstance

  constructor(base: string) {
    this.url = base
    this.axiosInstance = axiosInstance
  }

  list(params = {}): Promise<T[]> {
    return this.axiosInstance.get(this.url, {
      params,
    })
  }

  list_page(params = {}): Promise<PageData<T>> {
    return this.axiosInstance.get(this.url, {
      params,
    })
  }

  create(data: Omit<T, 'id'>): Promise<T> {
    return this.axiosInstance.post(this.url, data)
  }

  retrieve(id: number): Promise<T> {
    return this.axiosInstance.get(`${this.url}/${id}`)
  }

  update(id: number, data: Omit<T, 'id'>): Promise<T> {
    return this.axiosInstance.put(`${this.url}/${id}`, data)
  }

  partialUpdate(id: number, data: T): Promise<T> {
    return this.axiosInstance.patch(`${this.url}/${id}`, data)
  }

  destroy(id: number): Promise<T> {
    return this.axiosInstance.delete(`${this.url}/${id}`)
  }
}
